import moment from "moment";
moment.locale("it");

export default {
  filters: {
    now: function () {
      return moment();
    },
    date: function (date) {
      return moment(date).format('DD MMMM YYYY');
    },
    dateComp: function (date) {
        // console.log("dateComp:" + date)
        if (!date) return ""  
        else return moment(date).format('DD/MM/YYYY');
    },
    ISOString: function (date) {
      return moment(date).format();
    },
    time: function (date) {
      return moment(date).format('HH:mm');
    },
    fromTime: function(string) {
      return moment.utc(string, 'HH:mm').format()
    }
  },
};